// for add employee

export const RESET_EDIT_COMPANY_INFO = "reset_company_info";
export const EDIT_COMPANY_INFO = "company_info";
export const EDIT_COMPANY_INFO_SUCCESS = "company_info_success";
export const EDIT_COMPANY_INFO_FAILURE = "company_info_failure";
